import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "female",
  "use": "female-usage",
  "viewBox": "0 0 22 20",
  "content": "<symbol viewBox=\"0 0 22 20\" xmlns=\"http://www.w3.org/2000/svg\" id=\"female\"><path d=\"M8.399 12.327c-.688.88-2.238 1.345-4.872 2.102l-.655.21c-1.695.497-2.427 1.304-2.71 2.222-.23.782-.166 1.638-.102 2.47.025.247.039.458.051.669H21.02c.012-.125.012-.273.025-.408.039-.893.078-1.85-.244-2.73h-.012c-.347-.905-1.143-1.724-2.826-2.221l-.668-.21c-2.626-.753-4.187-1.214-4.878-2.11.472-.078.82-.148.82-.148.452-.115.926-.209 1.384-.356.46-.147.916-.321 1.355-.523.443-.203.477-.525.153-.893-.644-.732-.935-1.627-1.055-2.563-.122-.95-.15-1.913-.205-2.87a4.106 4.106 0 0 0-.006-.08C14.748 2.001 12.666.07 10.686.001L10.676 0h-.531c-.18.032-.359.071-.533.119-.156.039-.307.087-.454.144-.38.14-.742.326-1.083.567-1.286.913-1.83 2.19-2.031 3.724-.098.743-.224 1.493-.287 2.24-.101 1.208-.306 2.389-1.032 3.41-.562.735-.532.915.322 1.244.675.26 1.384.434 2.08.645.113.034.23.053.328.078 0 0 .408.074.944.156z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/female.svg
// module id = 1549
// module chunks = 0